import { useEffect, useState } from "react";
import ProfileModal from "../../shared/Modals/ProfileModal";
import { clearStorage, getUserData } from "../../system";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../redux/actions";

const Header = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const profileData = useSelector((s) => s.userReducer.profileData);
  const Logout = () => {
    clearStorage();
    navigate("/login");
  };

  useEffect(() => {
    const decryptedData = getUserData();
    dispatch(userActions.getProfileData(decryptedData.id));
  }, []);

  return (
    <header id="page-topbar">
      <ProfileModal showModal={showModal} setShowModal={setShowModal} />

      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex w-75 justify-contrent-center align-items-center">
          </div>

          <div className="d-flex align-items-center">
            <div className="dropdown ms-sm-3 header-item">
              <button
                type="button"
                className="btn material-shadow-none"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="d-flex align-items-center">
                  <img
                    className="rounded-circle header-profile-user"
                    src={process.env.REACT_APP_STORAGE_URL + profileData.picUrl}
                    alt="Header Avatar"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "assets/images/users/avatar-1.png";
                    }}
                  />

                  <span className="text-start ms-xl-2">
                    <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text text-light">
                      {profileData?.name}
                    </span>
                    {/* <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                      Founder
                    </span> */}
                  </span>
                </span>
              </button>

              <div className="dropdown-menu dropdown-menu-end">
                <h6 className="dropdown-header">Welcome {profileData?.name}!</h6>

                <button
                  className="dropdown-item"
                  onClick={() => setShowModal(true)}
                >
                  <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1" />
                  <span className="align-middle">Profile</span>
                </button>

                <div className="dropdown-divider" />

                <button className="dropdown-item" onClick={Logout}>
                  <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />
                  <span className="align-middle" data-key="t-logout">
                    Logout
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
